import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var DocTextIcon24Regular = forwardRefAndName('DocTextIcon24Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 24
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M7.5 16C7.5 15.5858 7.83579 15.25 8.25 15.25H12.5C12.9142 15.25 13.25 15.5858 13.25 16C13.25 16.4142 12.9142 16.75 12.5 16.75H8.25C7.83579 16.75 7.5 16.4142 7.5 16Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M8.25 12.25C7.83579 12.25 7.5 12.5858 7.5 13C7.5 13.4142 7.83579 13.75 8.25 13.75H15.75C16.1642 13.75 16.5 13.4142 16.5 13C16.5 12.5858 16.1642 12.25 15.75 12.25H8.25Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.75 18C19.75 20.0711 18.0711 21.75 16 21.75H8C5.92893 21.75 4.25 20.0711 4.25 18V6C4.25 3.92893 5.92893 2.25 8 2.25H13.0494C13.7787 2.25 14.4782 2.53973 14.9939 3.05546L18.9445 7.00605C19.4603 7.52178 19.75 8.22125 19.75 8.9506V18ZM5.75 6C5.75 4.75736 6.75736 3.75 8 3.75H12.25V7C12.25 8.51878 13.4812 9.75 15 9.75H18.25V18C18.25 19.2426 17.2426 20.25 16 20.25H8C6.75736 20.25 5.75 19.2426 5.75 18V6ZM18.0352 8.25H15C14.3096 8.25 13.75 7.69036 13.75 7V3.96478C13.8153 4.00898 13.8767 4.05956 13.9333 4.11612L17.8839 8.06672C17.9404 8.12328 17.991 8.1847 18.0352 8.25Z"
    }))
  );
});